import "./ContactSection.scss";
import { useTranslation } from "react-i18next";
import contactTelegram from "../../assets/images/contactTelegram.svg";
import contactWhatsApp from "../../assets/images/contactWhatsApp.svg";
import contactViber from "../../assets/images/contactViber.svg";

const ContactSection = () => {
  const { t } = useTranslation();
  return (
    <div className="contact-section-container" id="contact">
      <div className="main-title">{t("titles.contacts")}</div>
      <div className="contacts-options">
        <div className="sub-title">{t("subtitles.contactsSubtitle1")}</div>
        <div className="networks">
          <a href="https://t.me/+48660441569" target="_blank" rel="noreferrer">
            <img src={contactTelegram} alt="telegram"></img>
          </a>
          <a href="https://wa.me/48660441569" target="_blank" rel="noreferrer">
            <img src={contactWhatsApp} alt="whatsApp"></img>
          </a>
          <a href="viber://chat?number=%2B48660441569" target="_blank" rel="noreferrer">
            <img src={contactViber} alt="viber"></img>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
